import {Button, FormControl, InputLabel, MenuItem, Select, TextField, Typography} from '@material-ui/core';
import 'Agent/AgentForms/Marketing/components/MarketingViewCart.sass';
import 'Agent/AgentForms/Marketing/components/SearchForm.sass';
import './VCShippingAddress.sass';
import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Empty} from 'Core/models/Async';
import {ReducerState} from 'rootReducer';
import {
  addressIsChanged,
  addressSelection,
  changeUnValidatedAddressAccepted,
  changeValidateAddress,
  changeViewCart,
  changeIsPOBoxAddress,
  isAddressValidated,
  isPOBox,
  RequiredCheckoutCartFields,
  selectAddress,
  setCartAddress,
  setCartPhoneAndEmail,
  StateFilter,
  validateAddress,
  onBlurChangeHandler,
  changeValidAddressSelected,
} from '../ducks/Marketing';

const VCShippingAddress = () => {
  const {viewCart, missingRequiredFields, addressValidationResponse, unValidatedAddressAccepted, validAddressSelected, isPOBoxAddress} = useSelector(
    (state: ReducerState) => state.marketing
  );
  const [cartDataCopy, setCartDataCopy] = useState({...viewCart});
  const [addressConfirmed, setAddressConfirmed] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (addressConfirmed) {
      dispatch(changeViewCart({...cartDataCopy}));
    }
  }, [addressConfirmed]);

  useEffect(
    () => () => {
      dispatch(changeValidateAddress(new Empty()));
    },
    []
  );

  useEffect(() => {
    if (!unValidatedAddressAccepted) {
      dispatchChange();
    }
  }, [cartDataCopy.address]);

  useEffect(() => {
    if (!unValidatedAddressAccepted) {
      let zip = cartDataCopy.zip;
      if (zip?.length === 5 || zip?.length === 10) {
        dispatchChange();
      }
    }
  }, [cartDataCopy.zip]);

  useEffect(() => {
    if (!unValidatedAddressAccepted) {
      const delayDebounceFn = setTimeout(() => {
        dispatchChange();
      }, 1000);
      return () => clearTimeout(delayDebounceFn);
    }
  }, [cartDataCopy.city]);

  useEffect(() => {
    if (!unValidatedAddressAccepted) {
      dispatchChange();
    }
  }, [cartDataCopy.state]);

  const onBlurChange = onBlurChangeHandler(setCartDataCopy, cartDataCopy, dispatch);

  function dispatchChange() {
    setCartDataCopy(cartDataCopy);
    dispatch(changeViewCart({...cartDataCopy}));
    if (addressIsChanged(cartDataCopy, addressValidationResponse)) {
      if (
        cartDataCopy.address !== '' &&
        (cartDataCopy.zip !== '' || (cartDataCopy.city !== '' && cartDataCopy.state !== ''))
      ) {
        dispatch(validateAddress(cartDataCopy, missingRequiredFields));
        setAddressConfirmed(false);
        dispatch(changeUnValidatedAddressAccepted(false));
      }
    }
  }
  return (
    <div className="vc-shipping-address">
      <FormControl fullWidth={true}>
        <Typography variant="subtitle1" className="shipping-info-text">
          Physical address required for shipping; we cannot ship to a PO Box:
        </Typography>
      </FormControl>
      <FormControl className="field-section-account" fullWidth={true}>
        <TextField
          variant="outlined"
          label="Address Line 1"
          placeholder="Address Line 1"
          size="small"
          name="address"
          error={
            missingRequiredFields.includes(RequiredCheckoutCartFields.ADDRESS_LINE_1) && cartDataCopy.address === ''
          }
          value={cartDataCopy.address}
          onChange={e => {
            dispatch(changeUnValidatedAddressAccepted(false));
            dispatch(changeIsPOBoxAddress(isPOBox(e.target.value)));
            setCartAddress(e, setCartDataCopy, cartDataCopy);
          }}
        />
      </FormControl>
      <FormControl className="field-section-account" fullWidth={true}>
        <TextField
          variant="outlined"
          label="Address Line 2"
          placeholder="Address 2"
          size="small"
          name="address2"
          value={cartDataCopy.address2}
          onChange={e => {
            setCartAddress(e, setCartDataCopy, cartDataCopy);
          }}
        />
      </FormControl>
      <div className="flex-container">
        <FormControl className="flex-item-left">
          <TextField
            variant="outlined"
            label={
              missingRequiredFields.includes(RequiredCheckoutCartFields.ZIP) && cartDataCopy.zip === ''
                ? 'Zip is required'
                : 'Zip'
            }
            size="small"
            placeholder="Zip Code"
            name="zip"
            error={missingRequiredFields.includes(RequiredCheckoutCartFields.ZIP) && cartDataCopy.zip === ''}
            value={cartDataCopy.zip}
            onChange={e => {
              dispatch(changeUnValidatedAddressAccepted(false));
              setCartAddress(e, setCartDataCopy, cartDataCopy);
            }}
          />
        </FormControl>
        <div className="flex-item-middle"></div>
        <FormControl className="flex-item-right">
          <TextField
            variant="outlined"
            label={
              missingRequiredFields.includes(RequiredCheckoutCartFields.CITY) && cartDataCopy.city === ''
                ? 'City is required'
                : 'City'
            }
            size="small"
            placeholder="City"
            name="city"
            error={missingRequiredFields.includes(RequiredCheckoutCartFields.CITY) && cartDataCopy.city === ''}
            value={cartDataCopy.city}
            onChange={e => {
              dispatch(changeUnValidatedAddressAccepted(false));
              setCartAddress(e, setCartDataCopy, cartDataCopy);
            }}
          />
        </FormControl>
      </div>

      <div className="flex-container field-section-formNumber">
        <FormControl variant="outlined" className="flex-item-left">
          <InputLabel className="state-input-label" variant="outlined" htmlFor="uncontrolled-native">
            State
          </InputLabel>
          <Select
            variant="outlined"
            label={
              missingRequiredFields.includes(RequiredCheckoutCartFields.STATE) && cartDataCopy.state === ''
                ? 'State is required'
                : 'State'
            }
            placeholder="State"
            name="state"
            error={missingRequiredFields.includes(RequiredCheckoutCartFields.STATE) && cartDataCopy.state === ''}
            value={cartDataCopy.state}
            onChange={e => {
              dispatch(changeUnValidatedAddressAccepted(false));
              setCartAddress(e, setCartDataCopy, cartDataCopy);
            }}
            inputProps={{
              name: 'state',
              id: 'uncontrolled-native',
            }}
          >
            <MenuItem value="" disabled selected>
              Select State
            </MenuItem>
            {StateFilter.map(state => (
              <MenuItem key={state.value} value={state.value}>
                {state.value}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <div className="flex-item-middle"></div>
        <FormControl className="flex-item-right">
          <TextField
            variant="outlined"
            label={
              missingRequiredFields.includes(RequiredCheckoutCartFields.PHONE) && cartDataCopy.phoneNumber === ''
                ? 'Phone number is required'
                : 'Phone'
            }
            size="small"
            placeholder="Phone Number"
            name="phoneNumber"
            error={missingRequiredFields.includes(RequiredCheckoutCartFields.PHONE) && cartDataCopy.phoneNumber === ''}
            value={cartDataCopy.phoneNumber}
            onChange={e => setCartPhoneAndEmail(e, setCartDataCopy, cartDataCopy, missingRequiredFields, dispatch)}
            onBlur={e => onBlurChange(e)}
          />
        </FormControl>
      </div>
      <FormControl className="field-section-account" fullWidth={true}>
        <TextField
          variant="outlined"
          label={
            missingRequiredFields.includes(RequiredCheckoutCartFields.EMAIL) && cartDataCopy.email === ''
              ? 'Email is required'
              : 'Email'
          }
          size="small"
          placeholder="Email"
          name="email"
          error={missingRequiredFields.includes(RequiredCheckoutCartFields.EMAIL)}
          value={cartDataCopy.email}
          onChange={e => {
            setCartPhoneAndEmail(e, setCartDataCopy, cartDataCopy, missingRequiredFields, dispatch);
          }}
          onBlur={e => onBlurChange(e)}
        />
      </FormControl>

      {isPOBoxAddress && (isAddressValidated(addressValidationResponse) || !unValidatedAddressAccepted) && (
        <FormControl fullWidth={true}>
          <Typography variant="subtitle1" className="po-box-warning">
            Please enter a physical address for shipping. We cannot ship to a PO Box.
          </Typography>
        </FormControl>
      )}
      {addressValidationResponse.key === 'NotFound' &&
      !isAddressValidated(addressValidationResponse) &&
      !unValidatedAddressAccepted ? (
        <FormControl className="field-section-account address-validation-section" fullWidth={true}>
          <Typography align="center" variant="subtitle1" className="validation-message">
            We were unable to validate the address.
          </Typography>
          <Button
            className="validation-button accept-unvalidated"
            color="primary"
            onClick={e => dispatch(changeUnValidatedAddressAccepted(true))}
          >
            Click here to agree to use the address entered above.
          </Button>
        </FormControl>
      ) : (
        isAddressValidated(addressValidationResponse) &&
        !addressConfirmed &&
        !isPOBoxAddress && (
          <FormControl className="field-section-account address-validation-section" fullWidth={true}>
            <Typography align="center" variant="subtitle1" className="validation-message">
              Address match found, use this address?
            </Typography>
            <Button
              className="validation-button use-validated"
              variant={'contained'}
              onClick={e => {
                dispatch(changeUnValidatedAddressAccepted(true));
                dispatch(changeValidAddressSelected(true));
                selectAddress(addressValidationResponse, setCartDataCopy, cartDataCopy, setAddressConfirmed);
              }}
            >
              {addressSelection(addressValidationResponse)}
            </Button>
            {(validAddressSelected && !addressConfirmed && addressValidationResponse['Data'].validationMessage.includes("Everything confirmed")) && <Button
                className="validation-button confirm-entered"
                variant='contained'
                onClick={e => {
                  dispatch(changeUnValidatedAddressAccepted(true));
                  setAddressConfirmed(true);
                }}
              >
                Click here to agree to use the address entered above.
              </Button>}
          </FormControl>
        )
      )}
    </div>
  );
};

export default VCShippingAddress;
